<template>
  <import-charge-tab lob="Finance" />
</template>

<script>
import importChargeTab from '@/components/Cargo/Job/importCharge/importChargeTab'

export default {
  name: 'ImportChargeFinance',
  components: { importChargeTab }
}
</script>
